import { ROUTES } from "@/config/routes";

/** Navigate to App uninstalled page (full reload avoids stale React Query / account state). */
export function redirectToAppUninstalled(): void {
  const path = ROUTES.appUninstalled;
  if (window.location.pathname === path) {
    return;
  }
  window.location.assign(path);
}
